import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import VideoIllustration from '@wetransfer/transfer/component/illustration/video-illustration';
import TransferLink from '@wetransfer/transfer/component/transfer-link';
import ExperimentTransferDetails04CtaUpdate from '@wetransfer/transfer/constant/experiments/transfer-details-04-cta-update';
import NotificationPositions from '@wetransfer/transfer/constant/notification-positions';
import { trackAmplitudeEvent } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';
import { amplitudeAction } from '@wetransfer/transfer/modules/analytics/vendors/utils/trackUpload';
import Browser from '@wetransfer/transfer/modules/concorde-browser';
import I18n from '@wetransfer/transfer/modules/i18n';

class Link extends React.PureComponent {
  state = {
    copied: false,
  };

  transferLink = React.createRef();

  onLinkCopied = (copied) => this.setState({ copied });

  onCopyLink = () => {
    if (this.transferLink.current) {
      this.transferLink.current.copyUrlToClipboard();

      trackAmplitudeEvent({
        action: 'Transfer Link Copied',
        additionalProperties: {
          Context: 'Transfer Window',
        },
      });
    }
  };

  onSendAnother = () => {
    this.props.onRequestClose();

    trackAmplitudeEvent({
      action: amplitudeAction.TRANSFER_SEND,
      additionalProperties: {
        Step: 'Send Transfer Done',
        Action: 'Send Another',
        'Transfer Type': 'Link',
      },
    });
  };

  render() {
    const contentText = Browser.isMobile
      ? 'transfer.complete_mobile.link_text'
      : 'transfer.complete_link.text';

    const transferDoneClassNames = classNames('transfer__button', {
      'transfer__button--alt':
        !Browser.isMobile && ExperimentTransferDetails04CtaUpdate.isOn(),
    });

    return (
      <React.Fragment>
        <div className="transfer__contents">
          <VideoIllustration
            type="transfer-complete-upload"
            src="transfer_window/transfer_completed"
            variants={3}
            className="uploader__image"
          />
          <h2>{I18n.t('transfer.complete_link.title')}</h2>
          <p
            dangerouslySetInnerHTML={{
              __html: I18n.t(contentText),
            }}
            className="complete__text"
          />
          <TransferLink
            notificationPosition={NotificationPositions.transfer}
            ref={this.transferLink}
            noButton
            onLinkCopied={this.onLinkCopied}
          />
        </div>
        <div className="transfer__footer">
          {this.state.copied || Browser.isTablet ? (
            <button
              className={transferDoneClassNames}
              onClick={this.onSendAnother}
            >
              {I18n.t('transfer.buttons.done')}
            </button>
          ) : (
            <button className="transfer__button" onClick={this.onCopyLink}>
              {I18n.t('transfer.buttons.copy_link')}
            </button>
          )}
        </div>
      </React.Fragment>
    );
  }
}

Link.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

export default Link;
